/**
 * The ONE password rule for a new or changed password (2026-10-11).
 *
 * Sign-up said "at least 6 characters", most other forms said 8, and the
 * server required 8 with an uppercase letter, a lowercase letter, a number
 * and a symbol on some paths only. A family could pick a password one form
 * accepted and the next refused. This mirrors the server's rule exactly
 * (backend utils/security.js validatePasswordStrength, same order, same
 * messages), and every form shows PASSWORD_RULE_TEXT.
 *
 * Signing in, or linking an existing login, never checks this: an existing
 * password made under an older rule still works.
 */

export const PASSWORD_RULE_TEXT =
  "At least 8 characters, with an uppercase letter, a lowercase letter, a number and a symbol.";

const SYMBOL = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

/** The first thing wrong with a new password, or null when it meets the rule. */
export function passwordProblem(password: string | null | undefined): string | null {
  if (!password) return "Password is required";
  if (password.length < 8) return "Password must be at least 8 characters long";
  if (password.length > 128) return "Password must be less than 128 characters";
  if (!/[A-Z]/.test(password)) return "Password must contain at least one uppercase letter";
  if (!/[a-z]/.test(password)) return "Password must contain at least one lowercase letter";
  if (!/[0-9]/.test(password)) return "Password must contain at least one number";
  if (!SYMBOL.test(password)) return "Password must contain at least one special character";
  return null;
}
